<template>
  <div class="relative w-full rounded-image">
    <slot />
  </div>
</template>
